<template>
    <div class="mask" v-if="showFlag">

      <div  class="user-info" @click="stopPropa" >
        <div class="user-info-top">
        <div class="margin-top-xl margin-left-xl flex flex-row">
          <div><img class="user-ico-b" src="@/assets/images/user.png"/></div>
          <div class="flex flex-col">
            <div class="user-name">{{userName}}</div>
            <div class="user-level">{{memberLevelName}}</div>
          </div>
        </div>
        <div class="user-data border-box">
          <div class="flex flex-col">
              <div class="flex flex-center-sp font-bold">{{userInfo.collectCount}}</div>
              <div class="font-ms color-rgb-05" >累计被收藏数</div>
          </div>
          <div class="flex flex-col">
              <div class="flex flex-center-sp font-bold">{{userInfo.viewCount}}</div>
              <div class="font-ms color-rgb-05">累计被浏览数</div>
          </div>
          <div class="flex flex-col">
              <div class="flex flex-center-sp font-bold">{{userInfo.commentCount}}</div>
              <div class="font-ms color-rgb-05">累计被评论数</div>
          </div>
        </div>
        <div class="user-use flex flex-col">
          <div class="flex flex-space-between ">
            <div class="font-ms">当前文件：{{fileCount}}/{{maxFileCount}}</div>
            <div class="color-blue font-s" >升级</div>
          </div>
          <ProgressBar :precent="precent"></ProgressBar>
        </div>
        
        </div>
        <div class="user-info-bottom flex flex-col ">
            <div class="bottom-item flex flex-center-cz pointer" @click="personSet">个人设置</div>
            <div v-if="false" class="bottom-item flex flex-center-cz pointer">交易中心</div>
            <div class="bottom-item flex flex-center-cz pointer" @click="help">帮助中心</div>
            <div v-if="false" class="bottom-item flex flex-center-cz pointer">更新日志</div>
            <div class="bottom-item flex flex-center-cz pointer" @click="exit">退出登录</div>
        </div>
        <div class="user-info-sjx"></div>  
        <UserEditModal :open="showUserEditModal" @close="showUserEditModal = false" @confirm="userConfrim"></UserEditModal>
    </div>

    </div>
    
  </template>
   
  <script>
  
  import {strToFloat,isEmpty} from '@/utils/sysUtils'
  import {userTotal,editUser} from '@/api/api.js';
  import ProgressBar from '@/components/progressBar/ProgressBar.vue'
  import UserEditModal from '@/views/modal/UserEditModal.vue'
  import {docCount} from '@/api/api.js';


  export default {
      name: 'UserInfo',
      components: {
        ProgressBar,UserEditModal
      },
      props: {
          show: {default: false},
      },
      watch: {
        show(val) {
            this.showFlag = val
            if (this.showFlag == true) {
              this.getLoginInfo();
              this.showUserInfo();              
            }
        }
      },
      data() {
          return {
            fileCount: 0,
            precent: 0,
            showUserEditModal: false,
            userName: null ,
            maxFileCount: null,
            memberLevelName: null,
            userInfo: [],
            showFlag: false
          }
      },
  
      methods: {

        getLoginInfo() {
          if (isEmpty(sessionStorage.getItem("token"))) {
            sessionStorage.setItem("token", localStorage.getItem("token")) ;
            sessionStorage.setItem("userId", localStorage.getItem("userId")) ;
            sessionStorage.setItem("realname", localStorage.getItem("realname"));
            sessionStorage.setItem("sex", localStorage.getItem("sex"));
            sessionStorage.setItem("memberLevelName", localStorage.getItem("memberLevelName"));
            sessionStorage.setItem("maxFileCount", localStorage.getItem("maxFileCount"));
          }

          this.token = sessionStorage.getItem("token");
          this.userId = sessionStorage.getItem("userId");
          this.userName =  sessionStorage.getItem("realname");
          this.maxFileCount = sessionStorage.getItem("maxFileCount");
          this.memberLevelName = sessionStorage.getItem("memberLevelName");

          if (isEmpty(sessionStorage.getItem("token"))) {
            this.userName = "未登录"
          } else if (isEmpty(sessionStorage.getItem("realname"))) {
            this.userName = "无名氏"
          }

        },
        stopPropa(event) {
            event || (event = window.event);
            event.stopPropagation ? event.stopPropagation(): (event.cancelBubble = true);
        },

        showUserInfo() {
          userTotal(this.docId).then((res) => {
            console.log("user_info========",res);
              if ((res.data.success == true) && (res.data.result != null)) {
                this.userInfo = res.data.result;
              } 
          })
          docCount(this.docId).then((res) => {
            console.log("doccount========",res);
              if ((res.data.success == true) && (res.data.result != null)) {
                this.fileCount = res.data.result;
                this.precent = (strToFloat(this.fileCount) / strToFloat(this.maxFileCount)) * 100;
              } 
          })
        },
        help() {
          this.$router.push({
              path: '/help',
          })
        },
        exit() {
          sessionStorage.setItem('token', "")
          sessionStorage.setItem('userId', "")
          sessionStorage.setItem('userName', "")
          sessionStorage.setItem('realname', "")

          localStorage.setItem('token', "")
          localStorage.setItem('userId', "")
          localStorage.setItem('userName', "")
          localStorage.setItem('realname', "")

          this.$router.push({
              path: '/login',
          }) 
        },
        personSet() {
          this.showUserEditModal = true;
        },
        userConfrim(data) {
          console.log("data===", data);
          sessionStorage.setItem("realname",data.realname);
          sessionStorage.setItem("sex",data.sex);

          localStorage.setItem('realname', data.realname)
          localStorage.setItem('sex', data.sex)

          let param = {"realname": data.realname, "sex": data.sex, "id": sessionStorage.getItem("userId")}
          editUser(param).then((res) => {
              if (res.data.success == true ) {
                this.showUserEditModal = false;
                this.$emit("close")
              } else {
                this.$showToast({msg: '更新成功！' });   

              }
          })

          

        }

      }
  }
  </script>
  
  <style scoped>
    .user-info {
    position: absolute;
    background-color: #ccdff8;
    border-radius: 10px;
    top:50px;
    right: 10px;
    height: 460px;
    width: 285px;
    z-index: 999;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 1px;

  }

  .user-info-sjx {
    position: absolute;
    transform: rotate(45deg);
    top: -5px;
    right: 25px;
    width: 15px;
    height: 15px;
    z-index: 9999;
    background-color: #ccdff8;
  }

  .user-info-top {
    display: flex;
    padding-left: 8px;
    padding-right: 8px;
    flex-direction: column;
    border-radius: 10px 10px 0px 0px ;
    background-color: #ccdff8;
  }

  .user-info-bottom {
    background-color: #fff;
    border-radius: 0px 0px 10px 10px ;
    height: 250px;
    padding-top: 10px;
  }

  .bottom-item {
    height: 35px;
    padding-left: 10px;
  }
  .bottom-item:hover {
    background-color: #ccdff8;
  }


  .user-data {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content:space-evenly;
    align-items: center;
  }
  .user-use {
    background-color: #fff;
    border-radius: 8px ;
    padding-top: 5px;
    padding-left: 8px;
    padding-right: 8px;
    margin-top: 8px;
    height: 50px;
  }



  .user-ico-b {
    width: 42px;
    height: 42px;
  }

  .user-name {
    font-size: 14px;
    margin-left: 10px;
  }

  .user-level {
    font-size: 12px;
    margin-left: 10px;
  }


  </style>
  


// WEBPACK FOOTER //
// src/modules/userInfo/UserInfo.vue